/* tslint:disable */
/* eslint-disable */
/**
 * Scania Configurator
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { GuidedViewMenuLeafNode } from './GuidedViewMenuLeafNode'
import {
  GuidedViewMenuLeafNodeFromJSON,
  GuidedViewMenuLeafNodeFromJSONTyped,
  GuidedViewMenuLeafNodeToJSON,
} from './GuidedViewMenuLeafNode'
import type { GuidedViewMenuNode } from './GuidedViewMenuNode'
import {
  GuidedViewMenuNodeFromJSON,
  GuidedViewMenuNodeFromJSONTyped,
  GuidedViewMenuNodeToJSON,
} from './GuidedViewMenuNode'

/**
 *
 * @export
 * @interface GuidedViewMenuResultMenuTree
 */
export interface GuidedViewMenuResultMenuTree {
  /**
   *
   * @type {string}
   * @memberof GuidedViewMenuResultMenuTree
   */
  id: string
  /**
   *
   * @type {boolean}
   * @memberof GuidedViewMenuResultMenuTree
   */
  hasreadMore: boolean
  /**
   *
   * @type {string}
   * @memberof GuidedViewMenuResultMenuTree
   */
  shortText: string | null
  /**
   *
   * @type {boolean}
   * @memberof GuidedViewMenuResultMenuTree
   */
  isOpen: boolean
  /**
   *
   * @type {Array<GuidedViewMenuNode>}
   * @memberof GuidedViewMenuResultMenuTree
   */
  subMenus?: Array<GuidedViewMenuNode> | null
  /**
   *
   * @type {Array<GuidedViewMenuLeafNode>}
   * @memberof GuidedViewMenuResultMenuTree
   */
  leafItems?: Array<GuidedViewMenuLeafNode> | null
  /**
   *
   * @type {boolean}
   * @memberof GuidedViewMenuResultMenuTree
   */
  hasSelectableItems: boolean
}

/**
 * Check if a given object implements the GuidedViewMenuResultMenuTree interface.
 */
export function instanceOfGuidedViewMenuResultMenuTree(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'id' in value
  isInstance = isInstance && 'hasreadMore' in value
  isInstance = isInstance && 'shortText' in value
  isInstance = isInstance && 'isOpen' in value
  isInstance = isInstance && 'hasSelectableItems' in value

  return isInstance
}

export function GuidedViewMenuResultMenuTreeFromJSON(
  json: any,
): GuidedViewMenuResultMenuTree {
  return GuidedViewMenuResultMenuTreeFromJSONTyped(json, false)
}

export function GuidedViewMenuResultMenuTreeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): GuidedViewMenuResultMenuTree {
  if (json === undefined || json === null) {
    return json
  }
  return {
    id: json['id'],
    hasreadMore: json['hasreadMore'],
    shortText: json['shortText'],
    isOpen: json['isOpen'],
    subMenus: !exists(json, 'subMenus')
      ? undefined
      : json['subMenus'] === null
      ? null
      : (json['subMenus'] as Array<any>).map(GuidedViewMenuNodeFromJSON),
    leafItems: !exists(json, 'leafItems')
      ? undefined
      : json['leafItems'] === null
      ? null
      : (json['leafItems'] as Array<any>).map(GuidedViewMenuLeafNodeFromJSON),
    hasSelectableItems: json['hasSelectableItems'],
  }
}

export function GuidedViewMenuResultMenuTreeToJSON(
  value?: GuidedViewMenuResultMenuTree | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    id: value.id,
    hasreadMore: value.hasreadMore,
    shortText: value.shortText,
    isOpen: value.isOpen,
    subMenus:
      value.subMenus === undefined
        ? undefined
        : value.subMenus === null
        ? null
        : (value.subMenus as Array<any>).map(GuidedViewMenuNodeToJSON),
    leafItems:
      value.leafItems === undefined
        ? undefined
        : value.leafItems === null
        ? null
        : (value.leafItems as Array<any>).map(GuidedViewMenuLeafNodeToJSON),
    hasSelectableItems: value.hasSelectableItems,
  }
}
